import { NgModule } from '@angular/core';
import { DateTimeRangeComponent } from './date-time-range.component';
import { DateModule } from '../../date.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DateTimeRangeComponent],
  imports: [DateModule, SvgIconModule],
  exports: [DateTimeRangeComponent],
})
export class DateTimeRangeModule {}
